import { Link } from "react-router-dom";
import { useLang } from "../context/LangContext";
import { Seo } from "../components/Seo";
import { Reveal, Hairline } from "../components/motion";
import { LEGACY_IMAGES } from "../lib/site";

const LegacyItem = ({ img, pos, aspect, title, desc, reversed, index }) => (
  <Reveal>
    <figure className="grid md:grid-cols-2 gap-10 md:gap-16 items-center">
      <div className={`relative ${reversed ? "md:order-last" : ""}`}>
        <div className="absolute -inset-3 border border-gold/20" />
        <img src={img} alt={title} loading="lazy" data-testid={`legacy-item-photo-${index + 1}`} className={`relative w-full ${aspect} object-cover photo-warm ${pos}`} />
      </div>
      <figcaption>
        <div className="font-serif text-sm text-gold/70">{String(index + 1).padStart(2, "0")}</div>
        <h2 className="font-serif text-2xl md:text-3xl text-cream mt-4 leading-snug">{title}</h2>
        <Hairline className="my-6 max-w-[120px]" />
        <p className="text-sand text-lg leading-relaxed font-light">{desc}</p>
      </figcaption>
    </figure>
  </Reveal>
);

export default function Legado() {
  const { t, path } = useLang();
  const L = t.legadoPage;

  return (
    <>
      <Seo title={L.metaTitle} description={L.metaDesc} pageKey="legado" />

      <section className="pt-28 pb-12 md:pt-40 md:pb-16 bg-ink">
        <div className="container-lux max-w-4xl">
          <Reveal><div className="overline mb-8">{L.overline}</div></Reveal>
          <Reveal delay={0.1}>
            <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.05] text-cream">{L.h1}</h1>
          </Reveal>
          <Hairline className="my-10 max-w-xs" delay={0.2} />
          <Reveal delay={0.2}><p className="text-sand text-xl font-light leading-relaxed max-w-2xl">{L.intro}</p></Reveal>
        </div>
      </section>

      <section data-testid="legacy-page-items" className="pb-16 md:pb-24 bg-ink">
        <div className="container-lux max-w-5xl space-y-14 md:space-y-24">
          {L.items.map((item, i) => (
            <LegacyItem key={item.title} img={LEGACY_IMAGES[i].src} pos={LEGACY_IMAGES[i].pos} aspect={LEGACY_IMAGES[i].aspect} title={item.title} desc={item.desc} reversed={i % 2 === 1} index={i} />
          ))}
        </div>
      </section>

      <section className="py-12 md:py-16 bg-ink-800 border-t border-gold/10">
        <div className="container-lux text-center">
          <Reveal>
            <Link to={`${path("home")}#contact`} data-testid="legacy-page-cta" className="btn-gold btn-caps">{t.common.book}</Link>
          </Reveal>
        </div>
      </section>
    </>
  );
}
